import { render, staticRenderFns } from "./TextCaption.vue?vue&type=template&id=30fc59a0"
import script from "./TextCaption.vue?vue&type=script&lang=js"
export * from "./TextCaption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports